if(!customElements.get('product-main')) {
  class ProductMain extends HTMLElement {
    static instanceCount = 0;

    constructor() {
      super();
      this.sectionId = this.dataset.section + '-' + ProductMain.instanceCount++; // for Unique product component IDs
      this.productData = JSON.parse(this.querySelector('[type="application/json"][data-product-json]').textContent);
      this.fillProductData();
      this.variantsElement = this.querySelector('product-variants');
      this.sellingPlanElement = this.querySelector('product-selling-plan');
      this.quantityElement = this.querySelector('.quantity-input');
      this.badgesSale = this.querySelectorAll('.sale[data-msgtpl]');
      this.badgesSoldOut = this.querySelectorAll('.badge.sold-out');
      this.discountTextElement = this.querySelector('[data-dynamic-discount-text]');
      this.variantTitleElements = this.querySelectorAll('[data-variant-title]');
      this.customTitleElements = this.querySelectorAll('[data-custom-title]');
      this.optionValues = {}
      const requiredOptionsSetting = ([] || []).concat(this.dataset.manualSelect ? this.dataset.manualSelect.split(',') : []).map(x=>x.trim());
      const requiredOptionsSettingUnique = [...new Set(requiredOptionsSetting)];
      this.requiredOptions = this.productData.options_with_values.filter(x=>(requiredOptionsSettingUnique.indexOf(x.name)>-1 || requiredOptionsSettingUnique.indexOf('*')>-1) && x.values.length>1).map(x=>x.name);
      if (this.requiredOptions.length > 0) {
        this.setAttribute('data-required', 'true');
      }
      if (this.quantityElement) {
        this.quantityElement.addEventListener('change', this.onQuantityElementChange.bind(this));
      }
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.addEventListener('sellingPlanChange', this.onVariantChange.bind(this));

      }

    fillProductData() {
      const isMerge = this.productData.is_product_merge;
      
        this.productData.options_with_values.forEach(option=>{
          option.values = option.values.map(x=>{
            return {"value": x, "available": true }; //availability calculated by filtered variants in getOptionValues function
          });
        });if (this.productData.is_product_main) {
        let altPerProduct = {}
        this.productData.media = Array.from(this.querySelectorAll('product-gallery [data-media-id]')).map((media)=>{
          let alt;
          if (!isMerge) {}
          return {
            "alt": alt,
            "id": media.getAttribute('data-media-id')
          };
        });
      }

    }

    isSwatchSelected() {
      return this.requiredOptions.length == 0 || this.requiredOptions.length < this.productData.options_with_values.length;
    }

    required(option, newValue) {
      var ix = this.requiredOptions.indexOf(option);
      if (typeof(newValue)!='undefined') {
        if (ix > -1) {
          this.requiredOptions.splice(ix, 1);
          if (this.requiredOptions.length == 0) {
            this.setAttribute('data-required', 'false');
          }
          return false;
        }
      }
      return ix > -1;
    }

    getCurrentVariant() {
      return this.variantsElement.getCurrentVariant();
    }
    getCurrentPlan() {
      return this.sellingPlanElement?.getCurrentPlan();
    }
    getQuantity() {
      return this.quantityElement ? this.quantityElement.value : 1;
    }
    onQuantityElementChange() {
      this.dispatchEvent(new CustomEvent('quantityChange', {detail: {"quantity":this.getQuantity()}}));
    }
    onVariantChange() {
      // Lightweight update of elements that not worth creating their own components
      var variant = this.getCurrentVariant();
      if (!variant) return;
      this.variantTitleElements.forEach(element=>{
        element.innerHTML = variant.title;
      });

      var customTitle = variant.custom_title || variant.metafield?.custom?.custom_title || variant.metafields?.custom?.custom_title;
      if (customTitle) {
        this.customTitleElements.forEach(element=>{
          element.innerHTML = customTitle;
        });
      }

      // Discount badges/text always compare against the variant's own (fixed)
      // compare_at_price — never a selling plan's own compare_at_price — so the
      // reference price doesn't shift when switching between one-time and subscribe.
      // Only the active price (plan price when subscribed) changes.
      var priced = this.getCurrentPlan() || variant;
      var customSavings = variant.custom_savings || variant.metafield?.custom?.custom_savings || variant.metafields?.custom?.custom_savings;
      var calculatedPercent = 0;

      if (priced.price < variant.compare_at_price) {
          calculatedPercent = customSavings || Math.round((1 - priced.price / variant.compare_at_price) * 100);
      }

      if (this.discountTextElement) {
          if (variant.available && calculatedPercent > 0) {
              this.discountTextElement.innerHTML = calculatedPercent + '% OFF AUTO-APPLIED TODAY ✅';
              this.discountTextElement.style.display = '';
          } else {
              this.discountTextElement.style.display = 'none';
          }
      }

      this.badgesSale.forEach(element=>{
        var sale = '';
        if (priced.price < variant.compare_at_price) {
          var percent = customSavings || Math.round((1 - priced.price / variant.compare_at_price) * 100);
          sale = element.dataset.msgtpl.replace('[percent]', percent);
        }
        element.style.display = variant.available && sale ? '' : 'none';
        element.innerHTML = sale;
      });

      this.badgesSoldOut.forEach(element=>{
        element.style.display = variant.available ? 'none' : '';
      });}}
  customElements.define('product-main', ProductMain);

  class ComponentProductCardAtc extends ProductMain {
    constructor() {
      super()
      this.swatches = this.querySelector('.swatch-group')
      this.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.defaultImage = this.querySelector('.img.main').getAttribute('data-srcset');
      this.currentImageUrl = '';
      this.imageObserver = null;
      this.clickOutHandler = null;
      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
      
      this.optionsButton = this.querySelector('.atc-options');
      if (this.optionsButton) {
        this.optionsButton.addEventListener('click', this.openOptions.bind(this));
        
      }


      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      if(this.quickViewBtn) {
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this));
      }

      var self = this;
      if (self.classList.contains('colors-out')) {
        setTimeout(function() { //workaround on ajax call, the following code mistakenly inits ProductSwatch before ProductVariants
          var origSwatches = self.querySelector('product-swatch.color-swatches');
          if (origSwatches) {
            //need to duplicate the whole product-variants component
            var pv = origSwatches.closest('product-variants');
            var tag = pv.outerHTML.replace('name="id"', '');
            var wrapper = document.createElement('div');
            wrapper.style.display = 'none';
            //must insert as Element, not HTML, otherwise the component would be reconstructed
            self.querySelector('add-to-cart-form').insertAdjacentElement('beforebegin', wrapper);
            wrapper.innerHTML = tag;
            //move the swatches inside the add-to-cart-form component to use existing css.
            self.querySelector('add-to-cart-form').insertAdjacentElement('afterbegin', wrapper.querySelector('product-swatch.color-swatches'));
          }
        }, 10);
      }
      if (window.LinkPrefetch && window.LinkPrefetch.addHoverListener) {
        window.LinkPrefetch.addHoverListener(this);
      }
    }

    // Added to match colors on product cards loaded through ajax, probably not needed for main product sections
    copySchemeFrom(el) {
      var lookForClasses = ['scheme','color-scheme-1','color-scheme-2','color-scheme-3','color-scheme-758443a7-8dcb-47bc-ac4b-0e1c36d74194','color-scheme-5408cc45-b54f-480e-8ab6-063e706911ff','color-scheme-d95bef9c-b32c-4b9e-ae99-fbe7391dd1d1','color-scheme-bc569100-62dd-4fd1-8791-bb9c4920dad4','color-scheme-70bc34ab-531e-463e-bccd-64cf80643c7b','color-scheme-0e240c00-a870-4802-bbce-7964913e1425', 'same-scheme-true', 'same-scheme-false'];
      lookForClasses.forEach(name=>{
        if (el.classList.contains(name)) {
          this.classList.add(name);
        } else {
          this.classList.remove(name);
        }
      })
      
    }

    openOptions(e) {
      e.preventDefault()
      const currentVariant = this.getCurrentVariant();
      if (currentVariant && currentVariant.available) {
        const inputs = this.querySelectorAll(
          'input:not([type="hidden"]):not([type="button"]):not([type="submit"]):not([type="reset"]), textarea, select'
        );
        if (inputs.length==0) {
          this.querySelector('.btn.add').click();
          return;
        }
      }
      
      if (this.querySelector('.atc-options-wrapper').classList.contains('open')) {
        return;
      }
      var container = this.querySelector('.atc-options-wrapper form');
      this.querySelector('.atc-options-wrapper').classList.add('open');
      $s.trapFocus(container);
      var self = this;
      if (!this.clickOutHandler) {
        this.querySelector('.close').addEventListener('click', this.closeOptions.bind(this));
      }
      this.clickOutHandler = function(evt) {
        if(container !== evt.target && !container.contains(evt.target)) {
          self.closeOptions.bind(self)();
        }
      }
      document.addEventListener('mousedown', this.clickOutHandler);
    }
    closeOptions() {
      this.querySelector('.atc-options-wrapper').classList.remove('open');
      document.removeEventListener('mousedown', this.clickOutHandler);
      $s.removeTrapFocus();
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          var enhancedDescription = section.querySelector('.enhanced-description');
          if (enhancedDescription && enhancedDescription.querySelector('.expandable-default-open')) {
            enhancedDescription.querySelector('.accordion.open').classList.remove('open');
            enhancedDescription.querySelector('[aria-expanded=true]').ariaExpanded = false;
            enhancedDescription.querySelector('.expandable-default-open').classList.remove('expandable-default-open');
          }
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onVariantChange(event) {
      super.onVariantChange(event);
      var variant = event.detail.variant;
      var image = variant.featured_media && super.isSwatchSelected() ? variant.featured_media : null;
      var img = this.querySelector('.img.main');
      var width = Math.ceil(img.width / 100) * 100;
      if (image && img.classList.contains('under-video')) {
        this.querySelector('.video-wrap').remove();
        img.classList.remove('under-video');
      }

      if (img.classList.contains('lazyload')) {
        img.setAttribute('data-srcset', image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage);
      } else {
        this.currentImageUrl = image ? $s.buildImgSrcset(image.src, image.width) : this.defaultImage;
        if (!this.imageObserver) {
          if (!img.classList.contains('lazyloaded')) {
            this.imageObserver = new MutationObserver(mutations => {
              if (img.classList.contains('lazyloaded')) {
                this.imageObserver.disconnect();
                this.imageObserver = null;
                img.setAttribute('srcset', this.currentImageUrl);
              }
            });
            var config = { attributes: true, attributeFilter: ['class']};
            this.imageObserver.observe(img, config);
          } else {
            img.setAttribute('srcset', this.currentImageUrl);
          }
        }
      }

      // Update urls to variant
      var links = this.querySelectorAll('.product-card-url[href]');
      if (links.length > 0 && this.requiredOptions.length < this.productData.options_with_values.length) {
        var productUrl = new URL(links[0].getAttribute('href'), location.origin);
        productUrl.searchParams.set('variant', variant.id);
        links.forEach(link=>{
          link.setAttribute('href', productUrl.toString());
        });
        if (this.quickViewBtn) {
          this.quickViewBtn.dataset.url = productUrl.toString();
        }
      }
    }
  }
  customElements.define('product-card-atc', ComponentProductCardAtc);
}

if(!customElements.get('product-buttons')) {
  class ProductButtons extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.dynamicButtons = this.querySelector('.shopify-payment-button');
      this.mainAddButton = this.mainElement.querySelector('.btn.add');
      this.button = this.querySelector('.btn.add');
      if (this.button != this.mainAddButton) {
        this.button.addEventListener('click', (event)=>{
          event.preventDefault();
          event.stopImmediatePropagation();
          this.mainAddButton.click();
        });
      }

      this.mainElement.addEventListener('variantChange', (e)=>{
        var requiredBtn = this.querySelector('.btn.selection-required');
        if (this.required() && requiredBtn) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          requiredBtn.style.display = '';
          requiredBtn.innerHTML = this.requiredMessage;
        } else if(e.detail.variant && e.detail.variant.available) {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.remove('hide');
          }
          this.querySelector('.btn.add').style.display = '';
          this.querySelector('.sold-out-message').style.display = 'none';
          if (requiredBtn) requiredBtn.style.display = 'none';
      	} else {
          if (this.dynamicButtons) {
            this.dynamicButtons.classList.add('hide');
          }
          this.querySelector('.btn.add').style.display = 'none';
          this.querySelector('.sold-out-message').style.display = '';
          if (requiredBtn) requiredBtn.style.display = 'none';
      	}
      });
    }

    required() {
      if (this.mainElement.requiredOptions.length > 0) {
        this.requiredMessage = '';
        var label = this.mainElement.requiredOptions[0];
        var firstLetter = label[0].toLowerCase();
        var prep = 'aeiou'.indexOf(firstLetter)>-1 ? 'an' : 'a'; //english support only
        this.requiredMessage = lngg.product_main__select_option_label.replace('Select a ', 'Select ' + prep + ' ').replace(new RegExp(/{{ *option_name *}}/), label);
        return true;
      }
      return false;
    }
  }
  customElements.define('product-buttons', ProductButtons);
}

if(!customElements.get('product-sku')) {
  class ProductSKU extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
      	if(e.detail.variant) {
          if(e.detail.variant.sku) {
            this.closest('.module').style.display = 'block';
            this.innerHTML = e.detail.variant.sku;
          }else{
            this.closest('.module').style.display = 'none';
          }
      	}
      });
    }
  }
  customElements.define('product-sku', ProductSKU);
}

if(!customElements.get('variant-richtext-items')) {
  class VariantRichtextItems extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement?.addEventListener('variantChange', (e) => {
        this.querySelectorAll('.variant-content').forEach(el => {
          el.hidden = el.dataset.variantId != e.detail.variant?.id;
        });
      });
    }
  }
  customElements.define('variant-richtext-items', VariantRichtextItems);
}

if(!customElements.get('product-gallery') && !customElements.get('product-thumbs')) {
  class ProductMedia extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.itemsWrapper = this.querySelector('.items-wrapper');
      this.desktopStyle = this.dataset.desktop;
      this.desktopOrientation = this.dataset.desktopOrientation;
      this.mobileStyle = this.dataset.mobile;
      this.slider = false;

      this.mainElement.addEventListener('variantChange', this.onVariantChange.bind(this))
      window.addEventListener('mediaChange', this.onMediaChange.bind(this))
      setTimeout(()=>{
        this.onMediaChange();
      }, 10);
    }

    filterMedia(variant) {
      this.mainElement.productData.media.forEach((media)=>{
        var show = true;
        if(media.alt && media.alt!="") {
          var filter = media.alt.split(';');
          filter.forEach((f)=>{
            if(show) {
              var key = f.split(':')[0];
              var values = f.split(':')[1];
              var optionIndex = this.mainElement.productData.options_with_values.findIndex(x=>x.name==key.trim());
              if(optionIndex>=0 && values) {
                var found = false;
                values.split(',').forEach((value)=>{
                  if(variant.options[optionIndex]==value.trim()) {
                    found = true;
                  }
                });
                show = found;
              }
            }
          });
        }
        if(show) {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'block';
        } else {
          this.querySelector('[data-media-id="'+media.id+'"]').style.display = 'none';
        }
      });
      if(this.slider) {
        this.slider.refresh();
      }
    }

    onVariantChange() {
    }

    onMediaChange() {
    }

    initSlider() {
    }

    removeSlider() {
      if(this.slider) {
        this.slider.destroy();
        this.slider = false;
        this.classList.remove('keen');
        this.itemsWrapper.classList.remove('keen-slider');
        this.querySelectorAll('.media-wrap, .thumb-wrap').forEach((slide)=>{
          slide.classList.remove('keen-slider-slide')
        });
      }
    }

    showItem(mediaId, animate=true) {
      if(this.slider) {
        var index = Array.from(this.itemsWrapper.querySelectorAll('.media-wrap, .thumb-wrap'))
          .filter(x=>$s.isVisible(x)).findIndex(x=>x.dataset.mediaId==mediaId);
        if(animate) {
          this.slider.moveToSlideRelative(index, true);
        } else {
          this.slider.moveToSlideRelative(index, true, 0);
        }
      }
    }
  }
  
  class ProductGallery extends ProductMedia {
    constructor() {
      super();
      this.videoAutoplay = this.dataset.videoAutoplay;
      this.autoplayOptionsElement = this.videoAutoplay ? this.querySelector('.autoplay-options') : null;
      this.autoplayCheck = this.autoplayOptionsElement ? this.autoplayOptionsElement.querySelector('input') : null;
      if (this.autoplayCheck) {
        this.autoplayCheck.addEventListener('change', (e)=>{
          Cookies.set('autoplay', e.target.checked ? 'enabled' : 'disabled');
        });
        this.autoplayCheck.checked = Cookies.get('autoplay') !== 'disabled';
      }

      if(!this.closest('.tingle-modal')) {
        this.querySelectorAll('[data-file]').forEach((media)=>{
          media.addEventListener('click', (e)=>{
            var visibleItems = [];
            this.querySelectorAll('[data-media-id]').forEach((obj)=>{
              if($s.isVisible(obj)) {
                let element  = obj.querySelector('[data-file], video, iframe');
                if(element) {
                  visibleItems.push(element);
                }
              }
            });
            $s.photoSwipe(visibleItems, media);
          });
        });
        //3D Models
        this.querySelectorAll('[data-media-id].model-wrap').forEach((model)=>{
          model.addEventListener('click', (e)=>{
            $s.photoSwipe([model.querySelector('template').content.firstElementChild]);         
          });
        });
      }
    }

    onVariantChange(e) {
      var variant = e.detail.variant;
      var animate = e.detail.animate;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant);
        if(variant.featured_media && this.mainElement.isSwatchSelected()) {
          this.showItem(variant.featured_media.id, animate)
        }
      }
    }

    onMediaChange() {
      if($s.media.isSmall || this.desktopStyle=='carousel') {
        this.initSlider();
      } else {
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.media-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });

        var breakpoints = {};
        if(this.mobileStyle=='dots') {
          breakpoints['(max-width: '+window.breakpoints.small+')'] = {
            dots: this.querySelector('.keen-dots')
          }
        }
        if(this.querySelector('.keen-arrow')) {
          breakpoints['(min-width: '+(parseInt(window.breakpoints.small) + 0.001) +'rem)'] = {
            prevButton: this.querySelector('.keen-arrow.prev'),
            nextButton: this.querySelector('.keen-arrow.next')
          }
        }

        this.slider = new KeenSlider(this.itemsWrapper, {
          mode: "snap",
          loop: true,
          wheel: false,
          pageInfo: this.querySelector('.keen-slider-page'),
          slideChanged: (keen)=>{
            $s.pauseAllMedia(this);
            let canPlay = true;
            if (this.autoplayOptionsElement) {
              this.autoplayOptionsElement.classList.remove('visible');
            }
            if (this.videoAutoplay) {
              const media = keen.currentSlide().querySelector('.media');
              if (this.autoplayOptionsElement && media) { // && media is to only show the checkbox on video slides.
                this.autoplayOptionsElement.classList.add('visible');
                //TODO eval  checkbox
                this.autoplayCheck.checked = canPlay = Cookies.get('autoplay')!='disabled';
              }
              if (media && canPlay) {
                $s.playMedia(media);
              }
            }
            this.dispatchEvent(new CustomEvent('slideChanged', {detail: keen}));
          },
          breakpoints
        });
      }
    }
  }
  customElements.define('product-gallery', ProductGallery);

  class ProductThumbs extends ProductMedia {
    constructor() {
      super();
      this.mainGallery = this.mainElement.querySelector('product-gallery');
      // Read thumbnail slides settings from data attributes
      this.thumbnailsSlidesDesktop = parseInt(this.getAttribute('data-thumbnails-slides-desktop')) || 7;
      this.thumbnailsSlidesTablet = parseInt(this.getAttribute('data-thumbnails-slides-tablet')) || 4;
      this.thumbnailsSlidesMobile = parseInt(this.getAttribute('data-thumbnails-slides-mobile')) || 5;

      this.querySelectorAll('[data-media-id]').forEach((media)=>{
        media.addEventListener('click', (e)=>{
          this.mainGallery.showItem(media.dataset.mediaId);
        });
      });

      this.mainGallery.addEventListener('slideChanged', (e)=>{
        var currentSlide = e.detail.currentSlide();
        if(currentSlide) {
          var currentMediaId = currentSlide.dataset.mediaId;
          var currentSlideElement = this.querySelector('.current-slide');
          if(currentSlideElement) {
            currentSlideElement.classList.remove('current-slide');
          }
          this.querySelector('[data-media-id="'+currentMediaId+'"]').classList.add('current-slide');
          this.showItem(currentMediaId);
        }
      });

    }


    onVariantChange(e) {
      var variant = e.detail.variant;
      if(this.mainElement.productData.media && variant) {
        this.filterMedia(variant)
      }
    }

    onMediaChange() {
      if(($s.media.isSmall && this.mobileStyle=='thumbnails') || ($s.media.isMediumUp && (this.desktopStyle=='carousel') )) {
        this.style.display = 'block';
        this.initSlider();
      } else {
        this.style.display = 'none';
        this.removeSlider();
      }
    }

    initSlider() {
      if(!this.slider) {
        this.classList.add('keen');
        this.itemsWrapper.classList.add('keen-slider');
        this.itemsWrapper.querySelectorAll('.thumb-wrap').forEach((slide)=>{
          slide.classList.add('keen-slider-slide')
        });
        var breakpoints = {};
        breakpoints['(max-width: '+window.breakpoints.medium+')'] = {
          slidesPerView: this.thumbnailsSlidesTablet,
          spacing: 10,
          centered: false,
          vertical: false
        }
        breakpoints['(max-width: '+window.breakpoints.small+')'] = {
          slidesPerView: this.thumbnailsSlidesMobile,
          spacing: 10,
          centered: false,
          vertical: false
        }
        var sliderConfig = {
          mode: "snap",
          loop: true,
          centered: false,
          slidesPerView: this.thumbnailsSlidesDesktop,
          spacing: 15,
          prevButton: this.querySelector('.keen-arrow.prev'),
          nextButton: this.querySelector('.keen-arrow.next'),
          breakpoints
        };
        
        // Apply vertical orientation if needed
        if(this.desktopOrientation=='vertical') {
          sliderConfig.vertical = true;
          sliderConfig.slidesPerView = this.thumbnailsSlidesDesktop;
        }
        
        this.slider = new KeenSlider(this.itemsWrapper, sliderConfig);
        
      }
    }
  }
  customElements.define('product-thumbs', ProductThumbs);
}

if(!customElements.get('product-price')) {
  class ProductPrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.finalPriceElement = this.querySelector('.final');
      this.comparePriceElement = this.querySelector('.compare');
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false

      if(this.mainElement.classList.contains('product-card')){
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }else{
        var originalPricePrefix = '<span class="visually-hidden">'+lngg.product__original_price_label+': </span>'
        var finalPricePrefix = '<span class="visually-hidden">. '+lngg.product__final_price_label+': </span>'
      }

      this.listenEvents = ['variantChange','sellingPlanChange'];
      if (this.multiplyQuantity)
        this.listenEvents.splice(1, 0, 'quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var data = this.mainElement.getCurrentPlan() || this.mainElement.getCurrentVariant();
          var variant = this.mainElement.getCurrentVariant();
        	if(data) {
            var quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
        		this.finalPriceElement.innerHTML = $s.formatMoney(data.price * quantity).replace('.00','');

            // The compare (crossed-out) price always reflects the variant's own
            // regular price — it never switches to the selling plan's own
            // compare_at_price. Only the final price changes between one-time
            // and subscribe.
            if(variant.compare_at_price > data.price) {
              this.comparePriceElement.classList.remove('hide');
              this.comparePriceElement.innerHTML = originalPricePrefix + $s.formatMoney(variant.compare_at_price * quantity).replace('.00','');
        		  this.finalPriceElement.innerHTML = finalPricePrefix + $s.formatMoney(data.price * quantity).replace('.00','');
            } else {
              this.comparePriceElement.classList.add('hide');
              this.comparePriceElement.innerHTML = '';
            }
        	} else {
        		this.finalPriceElement.innerHTML = '';
            this.comparePriceElement.innerHTML = '';
        	}
          this.mainElement.dispatchEvent(new CustomEvent('priceChange', {detail: {price: data.price * quantity}}));
        });
      });
    }
  }
  customElements.define('product-price', ProductPrice);
}

if(!customElements.get('product-variants')) {
  class ProductVariants extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.mainElement.variantsInstances = (this.mainElement.variantsInstances || 0) +1;
      this.instanceIndex = this.mainElement.variantsInstances;
      this.variantInput = this.querySelector('[data-variant-id]');
      this.options = this.querySelectorAll('[data-option]');
      this.swatchImg = this.querySelector('product-swatch[data-use-img="true"]');
      this.variantsInfo = this.dataset.info ? JSON.parse(this.dataset.info) : null;
      this.mainElement.addEventListener('variantChange', (event)=> {
        if (this.variantInput.value != event.detail.variant.id) {
          this.setVariant(event.detail.variant);
        }
      })
      this.combinedListingOptions = [];
      

      this.bindOptions();
      setTimeout(()=>{
        this.variantChange(this.getCurrentVariant(), false);
        this.bindInfoElements();
      }, 10);
    }

    getOptionInfo(optionName) {
      return (this.variantsInfo ? this.variantsInfo.find(x=>x.title==optionName) : null) || {};
    }

    getOptionInfoIcon(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.description) {
        html = `
          <div class="option-info-icon">
            <button type="button" class="btn-open">?</button>
            <div class="option-info-content animation">${info.description}</div>
          </div>
        `;
      }

      return html;
    }
    getOptionInfoLink(optionName) {
      var info = this.getOptionInfo(optionName);
      var html = '';
      if (info.link_text) {
        if (info.link_target_image) {
          html = `
            <button type="button" class="option-info-link link" data-image-width="${info.link_target_image_native_width}" data-image-height="${info.link_target_image_native_height}" data-image="${info.link_target_image}" data-width="${info.link_target_image_width}">${info.link_text}</button>
          `;
        } else {
          html = `
            <a class="option-info-link link" href="${info.link_target_url}" target="_blank">${info.link_text}</a>
          `;
        }

      }

      return html;
    }

    getCurrentVariant() {
      return this.mainElement.productData.variants.find(x=>x.id==this.variantInput.value)
    }

    setVariant(variant) {
      if(typeof variant !== 'object') {
        variant = this.mainElement.productData.variants.find(x=>x.id==variant);
      }
      if(variant) {
        this.refreshOptions(-1, variant);
        this.variantChange(variant);
      }
    }

    variantChange(variant, animate=true) {
      if(variant) {
        this.variantInput.value = variant.id;
        
      } else {
        this.variantInput.value = '';
      }
      this.previousVariant = variant;
      this.variantInput.dispatchEvent(new Event('change', {bubbles: true}));
      this.mainElement.dispatchEvent(new CustomEvent('variantChange', {detail: {variant, animate}}));

      if (this.swatchImg) {
          //var variant = this.mainElement.productData.variants.
          var optionIndex = this.swatchImg.dataset.option/1 -1;
          this.swatchImg.querySelectorAll('[type="radio"]').forEach(radio=>{
            var label = radio.parentNode.querySelector('.label-inner');
            
            var matchingVariant = this.mainElement.productData.variants.find(v => {
              if (v.options[optionIndex] !== radio.value) return false;
              // All other options must match the current variant
              for (let i = 0; i < v.options.length; i++) {
                if (i === optionIndex) continue;
                if (v.options[i] !== variant.options[i]) return false;
              }
              return true;
            });
            if (!matchingVariant) {
              matchingVariant = this.mainElement.productData.variants.find(
                v => v.options[optionIndex] == radio.value
              );
            }
            let img = label.querySelector('img');
            if (matchingVariant.featured_media) {
              if (!img) {
                img = document.createElement('img');
                img.loading = 'lazy';
                img.width = 80;
                img.height = 80;
                img.alt = '';
                label.appendChild(img);
              }
              img.src = $s.imgUrlFilter(matchingVariant.featured_media.src, '80x');
              img.style.display = '';
            } else {
              if (img) {
                img.style.display = 'none';
              }
            }
          });

      }

    }

    calculateNewVariant(optionChanged, value) {
      var newVariants = this.mainElement.productData.variants;
      this.mainElement.productData.options_with_values.forEach((option, index)=>{
        if(optionChanged==index) {
          newVariants = newVariants.filter(x=>x.options[index]==value);
        } else {
          var tmpNewVariants = this.previousVariant ? newVariants.filter(x=>x.options[index]==this.previousVariant.options[index]) : [];
          if(tmpNewVariants.length==0) {
            tmpNewVariants = newVariants.filter(x=>x.options[index]==newVariants[0].options[index]);
          }
          newVariants = tmpNewVariants;
        }
      });
      return newVariants[0];
    }

    bindOptions() {
      this.options.forEach((element)=>{
        element.addEventListener('change', (e)=>{
          let optionIdx = element.dataset.option-1;
          let variant = this.calculateNewVariant(optionIdx, e.target.value);
          
          this.refreshOptions(element.dataset.option-1, variant);
          this.variantChange(variant);
        });
      });
    }

    
    
    bindInfoElements() {
      this.options.forEach((element)=>{
        var infoIcon = element.querySelector('.option-info-icon');
        var infoLink = element.querySelector('button.option-info-link');
        if (infoIcon) {
          $s.initFloatingPanel({container: infoIcon});
        }
        if (infoLink) {
          infoLink.addEventListener('click', (e)=>{
            var imageWidthPX = parseFloat(getComputedStyle(document.documentElement).fontSize) * infoLink.dataset.width;
            var html = `
              <div class="option-info-popup-content scheme" style="width: ${infoLink.dataset.width}rem">
                <img alt="" src="${infoLink.dataset.image + (infoLink.dataset.image.indexOf('?')==-1 ? '?' : '&') + 'width='+imageWidthPX}" width="${infoLink.dataset.imageWidth}" height="${infoLink.dataset.imageHeight}" />
              </div>
            `;
            $s.openModal(html, 'option-info-popup');
          });
        }
      });
    }

    // Get values with availability that depends on previous options
    getOptionValues(currentVariant) {
      var options = [];
      var variants = this.mainElement.productData.variants;
      options = structuredClone(this.mainElement.productData.options_with_values.map(x=>x.values));
      options.forEach((values, index) => {
        
        // Filter variants that match previous selections
        let filteredVariants = variants;
        for (let prev = 0; prev < index; prev++) {
          filteredVariants = filteredVariants.filter(
            v => v.options[prev] === currentVariant.options[prev]
          );
        }
        let retValues = [];
        values.forEach((valueObj) => {
          const matchingVariants = filteredVariants.filter(
            v => v.options[index] === valueObj.value
          );
          if (matchingVariants.length > 0) {
            valueObj.available = matchingVariants.some(v => v.available);
            retValues.push(valueObj);
          }
        })
        options[index] = retValues;
      });
      return options;
    }

    refreshOptions(updateOptionIndex=-1, currentVariant) {
      var optionValues = this.getOptionValues(currentVariant);
      this.options.forEach((element)=>{
        let index = element.dataset.option - 1;
        if(index > updateOptionIndex) {
          element.buildOptions(optionValues[index], currentVariant.options[index], currentVariant);
        }
        var optionValueElement = element.querySelector('.option-value');
        if(optionValueElement) {
          optionValueElement.innerHTML = currentVariant.options[index];
        }
      });
    }
  }
  customElements.define('product-variants', ProductVariants);
}

if(!customElements.get('product-variant-edit')) {
  class ProductVariantEdit extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.toggles = this.querySelectorAll('.toggle');
      this.toggles.forEach(btn=>{btn.addEventListener('click', this.onToggle.bind(this))});
      this.editing = false;
    }
    onToggle() {
      this.editing = !this.editing;
      var divVariants = this.querySelector('.variants');
      var divInfo = this.querySelector('.info');
      if (this.editing) {
        $s.expand([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.add('open')});
      } else {
        $s.collapse([divVariants]);
        this.toggles.forEach(btn=>{btn.classList.remove('open')});
      }
    }
  }
  customElements.define('product-variant-edit', ProductVariantEdit);
}

if(!customElements.get('product-swatch')) {
  class ProductSwatch extends HTMLElement {
  	constructor() {
      super();
      this.colorSwatchesOptions = ["Color"]
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.setAttribute('aria-labelledby', `swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
    	var optionElement = document.createElement('div');
      var mainElementId = this.mainElement.dataset.productId;
      var optionNameHandle = $s.handleize(this.label);
  		var labelText = this.label;
  		var labelSuffix = labelText.trim().endsWith(':') ? ' ' : ': ';
  		var html = `
        <div class="option-name small-label">
          ${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}">${labelText}${labelSuffix}</span>
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
        <div class="swatch-group flex flex-wrap"></div>
  		`;
  		this.innerHTML = html;
  		this.buildOptions(optionValues, defaultValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }
      const isInteractive = !this.closest('[aria-hidden="true"]');
  		options.forEach((option, index)=>{
        var optionNameHandle = $s.handleize(this.label);
        var optionValueHandle = $s.handleize(option.value);
        var id = `swatch2-${this.optionNumber}-${$s.handleize(option.value)}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var soldOut = (!option.available ? '<span class="visually-hidden"> (Sold Out)</span>' : '');
        
  			html += `
          <div class="swatch" data-available="${option.available}">
            <input type="radio" id="${id}" name="swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" ${!isInteractive ? 'tabindex="-1"':''} />
  				  <label for="${id}">
              <div class="label-inner flex align-items-center justify-content-center animation ${this.colorSwatchesOptions.indexOf(this.label)>-1 ? 'color-'+optionValueHandle : ''} ${optionNameHandle}-${optionValueHandle}">
              	<span>${option.value}${soldOut}</span>
              </div>
            </label>
          </div>
  			`;
  		});
  		var group = this.querySelector('.swatch-group');
  		group.innerHTML = html;

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true})
      } else {
        this.setAttribute('data-required', 'false');
        if(defaultValue && group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]')) {
          group.querySelector('input[value="'+$s.escapeJsDomAttribute(defaultValue)+'"]').checked = true;
        } else {
          group.querySelector('input').checked = true;
        }
      }
    }
  }
  customElements.define('product-swatch', ProductSwatch);
}

if(!customElements.get('product-dropdown')) {
  class ProductDropdown extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';

      this.buildOptionSelector();

      if (this.required()) {
        var select = this.querySelector('select');
        this.setAttribute('data-required', 'true');
        select.addEventListener('change', ()=>{
          this.setAttribute('data-required', 'false');
          this.required(false);
          select.querySelector('[disabled]').remove();
        }, {once: true})
      }
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];

      var optionId = 's-' + this.mainElement.sectionId+'-option-'+this.optionNumber + '-' + this.variantsElement.instanceIndex;
      var optionElement = document.createElement('div');
      const isInteractive = !this.closest('[aria-hidden="true"]');
      var labelText = this.label;
      var labelSuffix = labelText.trim().endsWith(':') ? ' ' : ': ';
      var html = `
        <label class="option-name small-label" for="${optionId}">
        ${this.infoIcon}${labelText}${labelSuffix}
        ${this.infoLink}
        </label>
        <div class="field">
          <svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"/></svg> 
          <select id="${optionId}" name="swatch-${optionId}" ${!isInteractive ? 'tabindex="-1"':''}></select>
        </div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptions(options, defaultValue) {
    	var html = '';
      if (this.required()) {
  			html += `<option value="${defaultValue || ''}" disabled selected>${lngg.general__forms__select_option_label}</option>`;
      } else {
        this.setAttribute('data-required', 'false');
      }
  		options.forEach((option, index)=>{
  			let soldOut = (!option.available ? lngg.product_main__sold_out_option_value : '');
  			html += `<option value="${$s.escapeDomAttribute(option.value)}">${option.value}${soldOut}</option>`;
  		});
  		var select = this.querySelector('select');
  		select.innerHTML = html;

  		if(defaultValue) {
    		var newValueIndex = Array.from(select.options).findIndex(x=>x.value==defaultValue);
    		if(newValueIndex>=0) {
    			select.selectedIndex = newValueIndex;
    		}
  		}
    }
  }
  customElements.define('product-dropdown', ProductDropdown);
}

if(!customElements.get('product-bundle-swatch')) {
  class ProductBundleSwatch extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.variantsElement = this.closest('product-variants') || this.mainElement.querySelector('product-variants');
      this.optionNumber = this.dataset.option;
      this.label = this.dataset.label;
      this.isV2 = (this.label || '').trim().toLowerCase() === 'quantity-v2';
      this.infoIcon = this.variantsElement.getOptionInfoIcon(this.label) || '';
      this.infoLink = this.variantsElement.getOptionInfoLink(this.label) || '';
      this.setAttribute('aria-labelledby', `bundle-swatchgroup-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`);
      if (this.isV2) {
        this.classList.add('product-bundle-swatch--v2');
      }

      this.buildOptionSelector();
    }

    required(newValue) {
      return this.mainElement.required(this.label, newValue);
    }

    buildOptionSelector() {
      var currentVariant = this.mainElement.getCurrentVariant();
      var optionValues = this.variantsElement.getOptionValues(currentVariant)[this.optionNumber-1];
      var defaultValue = currentVariant.options[this.optionNumber-1];
      var labelText = this.label;
      var labelSuffix = labelText.trim().endsWith(':') ? ' ' : ': ';
      var html = `
        <div class="option-name small-label visually-hidden">
          ${this.infoIcon}
          <span id="${this.getAttribute('aria-labelledby')}">${labelText}${labelSuffix}</span>
          <span aria-hidden="true" class="option-value">${defaultValue}</span>
          ${this.infoLink}
        </div>
        <div class="bundle-swatch-group flex flex-wrap"></div>
      `;
      this.innerHTML = html;
      this.buildOptions(optionValues, defaultValue);

      if (this.isV2) {
        this.setupSubscribeToggle();
      }
    }

    setupSubscribeToggle() {
      var form = this.closest('form');
      this.sellingPlanInput = (form || this.mainElement).querySelector('[name="selling_plan"]');
      if (!this.sellingPlanInput && form) {
        this.sellingPlanInput = document.createElement('input');
        this.sellingPlanInput.type = 'hidden';
        this.sellingPlanInput.name = 'selling_plan';
        form.appendChild(this.sellingPlanInput);
      }

      this.updateSubscribeState();
    }

    getSellingPlanById(id) {
      var groups = (this.mainElement.productData && this.mainElement.productData.sellingPlanGroups) || [];
      for (var i = 0; i < groups.length; i++) {
        var plan = groups[i].selling_plans.find(x => x.id == id);
        if (plan) return plan;
      }
      return null;
    }

    getSubscribeAllocation(variant) {
      if (!variant || !variant.selling_plan_allocations || !variant.selling_plan_allocations.length) return null;

      var optionValue = variant.options[this.optionNumber - 1] || '';
      var monthsMatch = optionValue.match(/(\d+)\s*Month/i);
      var months = monthsMatch ? parseInt(monthsMatch[1], 10) : null;

      if (months) {
        // Match the selling plan whose own name mentions the same number of
        // months as the currently selected bundle size (e.g. "6 Month Supply"
        // -> a plan named "Every 6 Months"), instead of blindly taking the
        // first allocation, which may belong to an unrelated/default plan.
        for (var i = 0; i < variant.selling_plan_allocations.length; i++) {
          var allocation = variant.selling_plan_allocations[i];
          var plan = this.getSellingPlanById(allocation.selling_plan_id);
          if (!plan || !plan.name) continue;
          var planMonthsMatch = plan.name.match(/(\d+)\s*Month/i);
          if (planMonthsMatch && parseInt(planMonthsMatch[1], 10) === months) {
            return allocation;
          }
        }
      }

      // Fallback: no name-matched plan found, use the first allocation.
      return variant.selling_plan_allocations[0] || null;
    }

    updateSubscribeState() {
      if (!this.isV2) return;

      var currentVariant = this.mainElement.getCurrentVariant();
      var allocation = this.getSubscribeAllocation(currentVariant);

      // Quantity-v2 offers are always a subscription — no checkbox, no
      // one-time option, no visible indicator — so the plan is forced on
      // silently whenever one exists.
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = allocation ? allocation.selling_plan_id : '';
        this.sellingPlanInput.dispatchEvent(new Event('change', {bubbles: true}));
      }
    }

    getVariantForOptionValue(optionValue, currentVariant) {
      var optionIndex = this.optionNumber - 1;
      var variants = this.mainElement.productData.variants;
      
      // Filter variants that match previous selections
      let filteredVariants = variants;
      for (let prev = 0; prev < optionIndex; prev++) {
        filteredVariants = filteredVariants.filter(
          v => v.options[prev] === currentVariant.options[prev]
        );
      }
      
      // Find variant with matching option value
      var matchingVariant = filteredVariants.find(v => v.options[optionIndex] === optionValue);
      return matchingVariant || null;
    }

    formatPrice(price) {
      return $s.formatMoney(price).replace('.00', '');
    }

    calculateSavings(variant) {
      if (!variant.compare_at_price || variant.compare_at_price <= variant.price) {
        return null;
      }
      var savings = variant.compare_at_price - variant.price;
      return this.formatPrice(savings);
    }

    calculateSavingsPercent(variant) {
      if (!variant.compare_at_price || variant.compare_at_price <= variant.price) {
        return null;
      }
      return Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100);
    }

    calculatePerMonthPrice(optionValue, variant) {
      var match = optionValue.match(/(\d+)\s*Month/i);
      var months = match ? parseInt(match[1], 10) : 1;
      if (!months || months < 1) months = 1;
      // Round to the nearest whole currency unit (not just the nearest cent),
      // so per-month prices never show decimals.
      return Math.round(variant.price / months / 100) * 100;
    }

    formatSplitPrice(price) {
      var formatted = this.formatPrice(price);
      var match = formatted.match(/^([^0-9]*)(.+)$/);
      var currency = match ? match[1] : '';
      var amount = match ? match[2] : formatted;
      return '<span class="price-currency">' + currency + '</span><span class="price-amount">' + amount + '</span>';
    }

    formatUnitPrice(variant) {
      if (!variant.unit_price || !variant.unit_price_measurement) {
        return null;
      }
      // Round to the nearest whole currency unit (not just the nearest cent),
      // so the unit price never shows decimals.
      var roundedUnitPrice = Math.round(variant.unit_price / 100) * 100;
      var unitPrice = this.formatPrice(roundedUnitPrice);
      var customUnit = "cupper";
      var fallbackUnit = (variant.unit_price_measurement.reference_unit || 'unit').toLowerCase();
      var unit = customUnit || fallbackUnit;
      var match = unitPrice.match(/^([^0-9]*)(.+)$/);
      var currency = match ? match[1] : '';
      var amount = match ? match[2] : unitPrice;
      return '<span class="unit-currency">' + currency + '</span><span class="unit-amount">' + amount + '</span><span class="unit-price-term">/' + unit + '</span>';
    }

    splitTitle(title) {
      return { mainTitle: title, freeText: '' };
    }

    updateCheckboxes() {
      var group = this.querySelector('.bundle-swatch-group');
      var selectedInput = group.querySelector('input[type="radio"]:checked');
      if (!selectedInput) return;

      var blockElement = this.closest('[class*="block-"]');
      var selectedBorderColor = blockElement ? getComputedStyle(blockElement).getPropertyValue('--bundle-selected-border').trim() || '#DC3900' : '#DC3900';
      var unselectedBorderColor = blockElement ? getComputedStyle(blockElement).getPropertyValue('--bundle-unselected-border').trim() || '#CCCCCC' : '#CCCCCC';

      group.querySelectorAll('.bundle-swatch-card').forEach(card => {
        var isSelected = card.querySelector('input[type="radio"]') === selectedInput;
        card.classList.toggle('selected', isSelected);

        var checkbox = card.querySelector('.bundle-checkbox');
        if (!checkbox) return;
        if (this.isV2) {
          checkbox.innerHTML = isSelected ?
            `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="#F16FA0" stroke-width="2"/><circle cx="10" cy="10" r="5" fill="#F16FA0"/></svg>` :
            `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="#F16FA0" stroke-width="2"/></svg>`;
        } else {
          checkbox.innerHTML = isSelected ?
            `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="${selectedBorderColor}" stroke-width="2"/><circle cx="10" cy="10" r="5" fill="${selectedBorderColor}"/></svg>` :
            `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="${unselectedBorderColor}" stroke-width="2"/></svg>`;
        }
      });
    }

    buildOptions(options, defaultValue, contextVariant) {
      var html = '';
      var currentVariant = contextVariant || this.mainElement.getCurrentVariant();
      const isInteractive = !this.closest('[aria-hidden="true"]');
      
      if (options.length > 0) {
        this.setAttribute('role', 'radiogroup');
      }

      // Collect all variants with feat_badge for this option group
      var badgeVariants = {};
      var optionIndex = this.optionNumber - 1;
      var filteredVariants = this.mainElement.productData.variants;
      for (let prev = 0; prev < optionIndex; prev++) {
        filteredVariants = filteredVariants.filter(
          v => v.options[prev] === currentVariant.options[prev]
        );
      }
      filteredVariants.forEach(variant => {
        if (variant.feat_badge) {
          badgeVariants[variant.id] = variant.feat_badge;
        }
      });

      var blockElement = this.closest('[class*="block-"]');
      var selectedBorderColor = blockElement ? getComputedStyle(blockElement).getPropertyValue('--bundle-selected-border').trim() || '#DC3900' : '#DC3900';
      var unselectedBorderColor = blockElement ? getComputedStyle(blockElement).getPropertyValue('--bundle-unselected-border').trim() || '#CCCCCC' : '#CCCCCC';

      options.forEach((option, index) => {
        var variant = this.getVariantForOptionValue(option.value, currentVariant);
        if (!variant) return;

        var optionValueHandle = $s.handleize(option.value);
        var id = `bundle-swatch-${this.optionNumber}-${optionValueHandle}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}`;
        var isSelected = option.value === defaultValue;
        var titleParts = this.splitTitle(option.value);
        var unitPrice = this.formatUnitPrice(variant);
        var savings = this.calculateSavings(variant);
        var variantBadge = badgeVariants[variant.id] || null;
        var variantImage = variant.swatch_image || variant.image || (variant.featured_media ? variant.featured_media.src : null);

        if (this.isV2) {
          var savingsPercent = this.calculateSavingsPercent(variant);
          var perMonthPrice = this.calculatePerMonthPrice(option.value, variant);
          html += `
            <div class="bundle-swatch-card v2 ${isSelected ? 'selected' : ''}" data-available="${option.available}">
              <input type="radio" id="${id}" name="bundle-swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" ${isSelected ? 'checked' : ''} ${!isInteractive ? 'tabindex="-1"':''} />
              <label for="${id}" class="bundle-card-label">
                <div class="bundle-card-content-v2">
                  <div class="bundle-col-left-v2">
                    <div class="bundle-checkbox">
                      ${isSelected ?
                        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="#F16FA0" stroke-width="2"/><circle cx="10" cy="10" r="5" fill="#F16FA0"/></svg>` :
                        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="#F16FA0" stroke-width="2"/></svg>`
                      }
                    </div>
                    <div class="bundle-title-v2">${titleParts.mainTitle}</div>
                  </div>
                  <div class="bundle-col-footer-v2">
                  <div class="bundle-per-month-v2">
                    ${this.formatSplitPrice(perMonthPrice)}<span class="bundle-per-month-label">/per month<br>&nbsp;value</span>
                  </div>
                  <div class="bundle-image-container">
                    ${variantImage ? `<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" data-li="st" d-src="${variantImage}" alt="${option.value}" loading="lazy" />` : ''}
                  </div>
                  <div class="bundle-col-right-v2">
                    ${savingsPercent ? `<div class="bundle-savings-pill">${savingsPercent}% OFF</div>` : ''}
                    ${variant.compare_at_price && variant.compare_at_price > variant.price ? `<div class="bundle-compare-v2">${this.formatSplitPrice(variant.compare_at_price)}</div>` : ''}
                    <div class="bundle-price-v2">${this.formatSplitPrice(variant.price)}</div>

                  </div>
                  </div>

                </div>
              </label>
            </div>
          `;
        } else {
          html += `
            <div class="bundle-swatch-card ${isSelected ? 'selected' : ''}" data-available="${option.available}">
              ${variantBadge ? `<div class="best-price-badge">${variantBadge}</div>` : ''}
              <input type="radio" id="${id}" name="bundle-swatch-${this.optionNumber}-${this.mainElement.sectionId}-${this.variantsElement.instanceIndex}" value="${$s.escapeDomAttribute(option.value)}" ${isSelected ? 'checked' : ''} ${!isInteractive ? 'tabindex="-1"':''} />
              <label for="${id}" class="bundle-card-label">
                <div class="bundle-card-content">
                  <div class="bundle-col-left">
                    <div class="bundle-checkbox">
                      ${isSelected ?
                        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="${selectedBorderColor}" stroke-width="2"/><circle cx="10" cy="10" r="5" fill="${selectedBorderColor}"/></svg>` :
                        `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="10" cy="10" r="9" stroke="${unselectedBorderColor}" stroke-width="2"/></svg>`
                      }
                    </div>
                    <div class="bundle-price-section">
                      ${unitPrice ? `<div class="bundle-unit-price">${unitPrice}</div>` : `
                        <div class="bundle-regular-price">
                          <span class="bundle-price">${this.formatSplitPrice(variant.price)}</span>

                          ${variant.compare_at_price && variant.compare_at_price > variant.price ? `<span class="bundle-compare-price">${this.formatSplitPrice(variant.compare_at_price)}</span>` : ''}
                        </div>
                      `}
                    </div>
                  </div>
                  <div class="bundle-image-container">
                    ${variantImage ? `<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=" data-li="st" d-src="${variantImage}" alt="${option.value}" loading="lazy" />` : ''}
                  </div>
                  <div class="bundle-col-right">
                    <div class="bundle-title">${titleParts.mainTitle}</div>
                    ${savings ? `<div class="bundle-savings small-label">${savings} OFF</div>` : ''}
                  </div>
                </div>
              </label>
            </div>
          `;
        }
      });

      var group = this.querySelector('.bundle-swatch-group');
      group.innerHTML = html;

      // Update checkboxes on change and trigger variant change
      group.querySelectorAll('input[type="radio"]').forEach(radio => {
        radio.addEventListener('change', (e) => {
          this.updateCheckboxes();
          // Trigger variant change event
          var optionIdx = this.optionNumber - 1;
          var variant = this.variantsElement.calculateNewVariant(optionIdx, e.target.value);
          this.variantsElement.refreshOptions(optionIdx, variant);
          this.variantsElement.variantChange(variant);
          this.updateSubscribeState();
        });
      });

      if (this.required()) {
        this.setAttribute('data-required', 'true');
        group.addEventListener('change', () => {
          this.setAttribute('data-required', 'false');
          this.required(false);
        }, {once: true});
      } else {
        this.setAttribute('data-required', 'false');
      }

      if (this.isV2) {
        this.updateSubscribeState();
      }
    }
  }
  customElements.define('product-bundle-swatch', ProductBundleSwatch);
}

if(!customElements.get('product-model')) {
  class ProductModel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = document.querySelector('.product-main-element[data-product-id="'+this.dataset.productId+'"]');

      window.Shopify.loadFeatures([{
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr.bind(this)
      }]);
    }

    setupShopifyXr() {
      if(!window.ShopifyXR) {
        document.addEventListener('shopify_xr_initialized', ()=>{
          this.setupShopifyXr();
        });
      } else {
        window.ShopifyXR.addModels(this.mainElement.productData.media.filter(x=>x.media_type=='model'));
        setTimeout(()=>{
          window.ShopifyXR.setupXRElements();
        }, 100);
      }
    }
  }
  customElements.define('product-model', ProductModel);
}

if(!customElements.get('product-sticky-panel')) {
  class ProductStickyPanel extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.scrollHandler = $s.throttle(this.onScroll.bind(this), 50);
      this.positionElement = this.mainElement.querySelector('.product-sticky-panel-position-placeholder');
    }

    connectedCallback() {
      if (this.positionElement) {
        window.addEventListener('scroll', this.scrollHandler);
      }
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.scrollHandler);
    }

    onScroll(event) {
      var bounds = this.positionElement.getBoundingClientRect();
      if (bounds.bottom < 0) {
        if (!this.showing) {
          this.classList.add('open');
          this.showing = true;
        }
      } else {
        if (this.showing) {
          this.classList.remove('open');
          this.showing = false;
        }
      }

    }

  }
  customElements.define('product-sticky-panel', ProductStickyPanel);
}

if(!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');

      this.mainElement.addEventListener('variantChange', (e)=>{
        if(e.detail.variant && e.detail.variant.available) {
          this.fetchAvailability(e.detail.variant.id);
        } else {
          this.innerHTML = '';
        }
      });
    }

    fetchAvailability(variantId) {
      let rootUrl = routes.root_url;
      const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup_availability`;

      $s.get({
        url: variantSectionUrl,
        success: (data)=>{
          this.innerHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.shopify-section').innerHTML;
          this.bindEvents();
        },
        error: ()=>{
          this.innerHTML = '';
        }
      });
    }

    bindEvents() {
      let button = this.querySelector('.pickup-popup-trigger');
      if(button) {
        button.addEventListener('click', ()=>{
          $s.openModal(this.querySelector('.pickup-availability-info'), 'pickup-availability-info-modal');
        });
      }
    }
  }
  customElements.define('pickup-availability', PickupAvailability);
}



//REF: FEATURE SELLING PLANS
if(!customElements.get('product-selling-plan')) {
  class ProductSellingPlan extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.input = this.querySelector('[name="selling_plan"]');
      this.inputFrequencyName = this.querySelector('[name="selling_plan_frequency"]');
      this.groupsContainer = this.querySelector('[data-groups]');
      this.plansContainer = null; //obtained after every group render
      this.textSubscribe = this.dataset.textSubscribe;
      this.textSubscribeSave = this.dataset.textSubscribeSave;
      this.textDeliveryFrequency = this.dataset.textDeliveryFrequency;
      this.subscribePriceNote = this.dataset.subscribePriceNote || '';
      this.installmentsCount = parseInt(this.dataset.installmentsCount) || 0;
      this.installmentsLogo = this.dataset.installmentsLogo || '';
      this.installmentsLogoAlt = this.dataset.installmentsLogoAlt || '';
      this.showFrequencyDropdown = this.dataset.showFrequencyDropdown !== 'false';
      this.subscribeExtraTemplate = this.querySelector('[data-subscribe-extra]');
      this.combineGroups = false;
      this.multiplyQuantity = typeof(this.dataset.multiplyQuantity)!='undefined' ? this.dataset.multiplyQuantity=='true' : false
      this.mainElement.lastSelectedSellingPlanId = this.input.value || this.mainElement.productData.sellingPlanGroups[0]?.selling_plans[0].id;

      this.input.addEventListener('change', ()=>{
        this.mainElement.dispatchEvent(new CustomEvent('sellingPlanChange', {detail: {sellingPlan: this.getCurrentPlan()}}));
      });

      this.watchAppstleWidget();

      this.listenEvents = ['variantChange'];
      if (this.multiplyQuantity)
        this.listenEvents.push('quantityChange');

      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          var wasSubscribed = this.input.value != '';

          this.groupsContainer.innerHTML = this.getGroupsHtml();
          this.cloneExtras();

          const checkbox = this.groupsContainer.querySelector('[data-selling-plan-checkbox]');
          if (!checkbox) { this.updateSellingPlan(''); this.showSellingPlanDetails(); return; }
          const planSelect = this.groupsContainer.querySelector('[data-plans] select');

          if (planSelect) {
            for (let i = 0; i < planSelect.options.length; i++) {
              if (planSelect.options[i].value == this.mainElement.lastSelectedSellingPlanId) {
                planSelect.selectedIndex = i;
                break;
              }
            }
            planSelect.addEventListener('change', (e)=>{
              if (checkbox.checked) this.updateSellingPlan(e.target.value);
            });
          }

          checkbox.checked = checkbox.disabled ? true : wasSubscribed;
          checkbox.addEventListener('change', ()=>{
            this.updateSellingPlan(checkbox.checked ? (planSelect ? planSelect.value : this.mainElement.lastSelectedSellingPlanId) : '');
          });

          this.updateSellingPlan(checkbox.checked ? (planSelect ? planSelect.value : this.mainElement.lastSelectedSellingPlanId) : '');
          this.showSellingPlanDetails();
        });
      });

    }

    cloneExtras() {
      if (this.subscribeExtraTemplate) {
        this.groupsContainer.querySelectorAll('[data-subscribe-body]').forEach((target)=>{
          target.innerHTML = '';
          target.appendChild(this.subscribeExtraTemplate.content.cloneNode(true));
        });
      }
    }

    getSellingPlanByIdWithGroup(id) {
      for (let i=0; id && i < this.mainElement.productData.sellingPlanGroups.length; i++) {
        const group = this.mainElement.productData.sellingPlanGroups[i];
        const sellingPlan = group.selling_plans.find(x=>x.id==id)
        if (sellingPlan) {
          return {sellingPlan, group}
        }
      }
      return {sellingPlan: null, group: null};
    }

    showSellingPlanDetails() {
      const currentVariant = this.mainElement.getCurrentVariant();
      const checkbox = this.groupsContainer.querySelector('[data-selling-plan-checkbox]');
      if (!checkbox) return;
      const optionWrap = checkbox.closest('.sp-option');
      const planSelect = optionWrap.querySelector('[data-plans] select');
      if (!planSelect) return;
      const planAlloc = currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==planSelect.value);
      if (!planAlloc) return;
      const quantity = this.multiplyQuantity ? this.mainElement.getQuantity() : 1;
      const titleEl = optionWrap.querySelector('.sp-option-title');
      const priceEl = optionWrap.querySelector('.sp-option-price');
      const noteEl = optionWrap.querySelector('[data-price-note]');

      // Only the checkbox state and the card border change on toggle — the
      // title, price, and price note always reflect the subscribe plan.
      const discountAmount = planAlloc.compare_at_price && planAlloc.compare_at_price > planAlloc.price
        ? $s.formatMoney(planAlloc.compare_at_price - planAlloc.price).replace('.00', '')
        : '';
      const optionPrice = $s.formatMoney(planAlloc.price * quantity).replace('.00', '');

      titleEl.innerHTML = this.textSubscribeSave + (discountAmount ? ' <span class="option-discount badge">' + discountAmount + '</span>' : '');
      priceEl.textContent = optionPrice;
      if (noteEl) {
        const {sellingPlan} = this.getSellingPlanByIdWithGroup(planSelect.value);
        noteEl.textContent = this.subscribePriceNote
          .replace('[price]', optionPrice)
          .replace('[plan]', sellingPlan ? sellingPlan.name : '');
      }
      return;
    }

    getInstallmentsHtml(amount) {
      if (this.installmentsCount <= 1) return '';
      var perPayment = $s.formatMoney(amount / this.installmentsCount).replace('.00', '');
      var logoHtml = this.installmentsLogo ? `<img class="sp-installments-logo" src="${this.installmentsLogo}" alt="${this.installmentsLogoAlt}">` : '';
      return `<span>${this.installmentsCount} payments of ${perPayment} by</span>${logoHtml}`;
    }

    updateSellingPlan(sellingPlanId) {
      this.input.value = sellingPlanId;
      if (sellingPlanId) {
        this.mainElement.lastSelectedSellingPlanId = sellingPlanId;
        const {sellingPlan, group} = this.getSellingPlanByIdWithGroup(sellingPlanId);
        this.inputFrequencyName.value = sellingPlan.name;
      } else {
        this.inputFrequencyName.value = '';
      }
      this.showSellingPlanDetails();
      this.input.dispatchEvent(new Event('change', {bubbles: true}));
      this.syncAppstleWidget(sellingPlanId);
    }

    syncAppstleWidget(sellingPlanId) {
      // Appstle's own subscription widget renders its own native
      // input[name="selling_plan"] radios (loaded lazily, after first user
      // interaction, by the theme's speed-optimization script). Since it
      // shares the same field name as our hidden input, keep it in lockstep
      // by clicking its matching radio whenever our selection changes.
      const appstleWidget = document.querySelector('.appstle_sub_widget');
      if (!appstleWidget) return;
      // Some products have multiple (often legacy/duplicate) selling plan
      // groups, so the exact plan ID we picked may not exist as a top-level
      // Appstle radio (it can be buried in Appstle's own frequency dropdown
      // instead). Fall back to "any subscribe radio" / "the one-time radio"
      // so the two widgets still agree on subscribe-vs-one-time.
      let targetRadio = appstleWidget.querySelector('input[name="selling_plan"][value="' + sellingPlanId + '"]');
      if (!targetRadio) {
        targetRadio = sellingPlanId
          ? appstleWidget.querySelector('input[name="selling_plan"]:not([value=""])')
          : appstleWidget.querySelector('input[name="selling_plan"][value=""]');
      }
      if (targetRadio && !targetRadio.checked) {
        targetRadio.click();
      }
      // Belt-and-suspenders: Appstle also tracks the active plan via this
      // data attribute on the widget wrapper, in case its cart-submit logic
      // reads it directly instead of (or in addition to) the radio state.
      appstleWidget.setAttribute('data-selected-selling-plan', sellingPlanId);
    }

    watchAppstleWidget() {
      if (document.querySelector('.appstle_sub_widget')) {
        this.syncAppstleWidget(this.input.value);
        return;
      }
      const observer = new MutationObserver(() => {
        if (document.querySelector('.appstle_sub_widget')) {
          this.syncAppstleWidget(this.input.value);
          observer.disconnect();
        }
      });
      observer.observe(document.body, {childList: true, subtree: true});
    }

    getGroupsHtml() {
      var currentVariant = this.mainElement.getCurrentVariant();
      if (!currentVariant) return '';

      var group = null;
      for (var i = 0; i < currentVariant.selling_plan_allocations.length; i++) {
        var g = this.mainElement.productData.sellingPlanGroups.find(x=>x.id==currentVariant.selling_plan_allocations[i].selling_plan_group_id);
        if (g) { group = g; break; }
      }
      if (!group) return '';

      var requiresSellingPlan = this.mainElement.productData.requiresSellingPlan;
      var optionId = `plan-option-subscribe-${this.mainElement.sectionId}`;
      return `
        <div class="sp-option">
          <input class="checkbox-custom" type="checkbox" id="${optionId}" data-selling-plan-checkbox ${requiresSellingPlan ? 'checked disabled' : ''}>
          <label class="checkbox-custom-label sp-option-label" for="${optionId}">
            <span class="sp-option-title"></span>
            <span class="sp-option-price"></span>
          </label>
          <div class="sp-option-body">
            <div class="sp-price-note" data-price-note></div>
            <div class="sp-installments" data-onetime-body></div>
            <div data-plans>${this.getPlansHtml(group)}</div>
            <div data-subscribe-body></div>
          </div>
        </div>
      `;
    }

    getPlansHtml(group) {
      //functionalities:
      // show or hide frequency dropdown when the One-Time option is selected
      // show a div with the frequency option when there is a single option but keep the <select> hidden
      //
      var currentVariant = this.mainElement.getCurrentVariant();
      var enabled = this.input.value!='';

      var html = '';
      const groupPlanAllocations = this.combineGroups ? currentVariant.selling_plan_allocations : currentVariant.selling_plan_allocations.filter(x=>x.selling_plan_group_id==group.id);
      var isOneOption = groupPlanAllocations.length==1;
      var forceHideSelect = !this.showFrequencyDropdown;
      html = `<div class="field no-label ${(isOneOption || forceHideSelect) ? 'hide' : ''}"><select aria-label="${this.textDeliveryFrequency}" id="frequency-${currentVariant.id}" class="${enabled ? 'enabled' : ''}" ${enabled ? '' : 'disabled="disabled"'}>`;
      groupPlanAllocations.forEach((plan)=>{
        const {sellingPlan} = this.getSellingPlanByIdWithGroup(plan.selling_plan_id);
        html += `<option value="${sellingPlan.id}">${sellingPlan.name}</option>`;
      });
      html += `</select><svg aria-hidden="true" class="icon icon-arrow-down" viewBox="0 0 32 32"><path class="stroke" d="M27,10,16,22,5,10"></path></svg></div>`;
      if (isOneOption && !forceHideSelect) {
        html += `<div class="selling-plan-name">${group.selling_plans[0].name}</div>`;
      }

      return html;
    }

    getCurrentPlan() {
      var currentVariant = this.mainElement.getCurrentVariant();
      if(currentVariant) {
        return currentVariant.selling_plan_allocations.find(x=>x.selling_plan_id==this.input.value);
      }
      return false;
    }

  }
  customElements.define('product-selling-plan', ProductSellingPlan);
}



if(!customElements.get('products-offer')) {
  class ProductsOffer extends HTMLElement {
    constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.checks = this.querySelectorAll('.offer-check');
      this.variantSelectors = this.querySelectorAll('select');
      this.checks.forEach(check=>{
        check.addEventListener('change', this.onCheck.bind(this));
      });
      this.mainElement.addEventListener('quantityChange', this.handleItemsQuantity.bind(this));
      this.variantSelectors.forEach(select=>{
        const item = select.closest('.product-offer-item');
        const updateItem = ()=>{
          this.updateImage(item, select.value);
          item.querySelectorAll('.final').forEach(priceElement=>{
            const quantityInput = item.querySelector('[data-name*="[quantity]');
            const quantity = quantityInput.value/1;
            const price = select.options[select.selectedIndex].dataset.price/1 * quantity;
            priceElement.innerHTML = $s.formatMoney(price).replace('.00', '');
          })
        }
        select.addEventListener('change', ()=>{
          this.mainElement.dispatchEvent(new CustomEvent('bundleChange'));
          updateItem();
        })
        updateItem();
      });
    }

    updateImage(item, variantId) {
      const img = item.querySelector('img');
      const json = JSON.parse(item.dataset.json);
      const image = json.images.find(x=>x.variants.split(',').some(v=>v==variantId)) || json.images[0];
      if (!img._defaultSrc) {
        img._defaultSrc = img.currentSrc;
      }
      img.src = image ? image.url : img._defaultSrc;
    }

    handleItemsQuantity(e) {
      this.checks.forEach(check=>{
        const item = check.closest('.product-offer-item');
        const bundleItem = item.querySelector('input[value="related_multiple"]');
        if (bundleItem) {
          const quantity = item.querySelector('[data-name*="[quantity]"]');
          quantity.value = e.detail.quantity;
        }
      })
      this.mainElement.dispatchEvent(new CustomEvent('bundleChange'));
    }

    onCheck(e) {
      const item = e.target.closest('.product-offer-item');
      const enabled = e.target.checked;
      const formItems = item.querySelectorAll('select, input[type="hidden"], input[type="text"]');
      formItems.forEach(field=>{
        if (enabled) {
          field.removeAttribute('disabled');
          field.setAttribute('name', field.dataset.name);
          item.classList.add('active');
        } else {
          field.setAttribute('disabled', true);
          field.removeAttribute('name');
          item.classList.remove('active');
        }
      })
      this.handleBundleProperties();
      this.mainElement.dispatchEvent(new CustomEvent('bundleChange'));
    }

    handleBundleProperties() {
      const formItems = this.querySelectorAll('.product-offer-common [data-name]');
      const enabled = Array.from(this.checks).some(check=>check.checked);
      formItems.forEach(field=>{
        if (enabled) {
          field.removeAttribute('disabled');
          field.setAttribute('name', field.dataset.name);
        } else {
          field.setAttribute('disabled', true);
          field.removeAttribute('name');
        }
      })
    }
  }
  customElements.define('products-offer', ProductsOffer);

  class ProductBundlePrice extends HTMLElement {
  	constructor() {
      super();
      this.mainElement = this.closest('.product-main-element');
      this.listenEvents = ['priceChange', 'bundleChange'];
      this.comparePrice = this.querySelector('.compare');
      this.finalPrice = this.querySelector('.final');
      let mainPrice = 0;
      this.listenEvents.forEach((event)=>{
        this.mainElement.addEventListener(event, (e)=>{
          if (e.detail?.price) {
            mainPrice = e.detail.price;
          }
          let totalPrice = mainPrice;
          const bundleItemsInput = this.mainElement.querySelectorAll('[name*="[id]"]');
          let isBundle = false;
          bundleItemsInput.forEach(input=>{
            const bundleItem = input.closest('.bundle-item');
            if (bundleItem) {
              const quantityInput = input.closest('.bundle-item').querySelector('[name*="[quantity]');
              const quantity = quantityInput.value/1;
              if (input.tagName=='SELECT') {
                totalPrice += input.options[input.selectedIndex].dataset.price/1 * quantity;
              } else {
                totalPrice += input.dataset.price/1 * quantity;
              }
              isBundle = true;
            }
          });

          const discountMultiplier = isBundle ? 1 - (this.dataset.discountPercentage||0)/100 : 1;
          if (discountMultiplier==1) {
            this.comparePrice.style.display = 'none';
          } else {
            this.comparePrice.style.display = '';
          }
    
          this.comparePrice.innerHTML = $s.formatMoney(totalPrice).replace('.00', '');
          this.finalPrice.innerHTML = $s.formatMoney(totalPrice * discountMultiplier).replace('.00', '');

          if (isBundle) {
            this.classList.add('is-bundle');
          } else {
            this.classList.remove('is-bundle');
          }
        });
      });
    }
  }
  customElements.define('product-bundle-price', ProductBundlePrice);
}

